import { getChannelAPIPath } from '@treasury/core/http';

AccountTransactionsService.$inject = ['$resource'];

export default function AccountTransactionsService($resource) {
    return {
        getAccountSummary,
        getAccountList,
        getAccountTransactions,
        getAccountTransactionsWithDates,
        getAccountsCoreData,
    };

    function getAccountTransactions(category, id) {
        return $resource(`${getChannelAPIPath()}accounttransactions/:id/:type`, {
            id,
            type: category,
        }).get().$promise;
    }

    function getAccountTransactionsWithDates(category, id, fromDate, toDate) {
        return $resource(
            `${getChannelAPIPath()}accounttransactions/GetByDateRange/:id/:type?fromDate=:fromDate&toDate=:toDate`,
            {
                id,
                type: category,
                fromDate,
                toDate,
            }
        ).get().$promise;
    }

    function getAccountSummary(category) {
        return $resource(`${getChannelAPIPath()}accounttransactions/?category=:category`, {
            category,
        }).query().$promise;
    }

    function getAccountList(category) {
        return $resource(`${getChannelAPIPath()}accounttransactions/accounts/?category=:category`, {
            category,
        }).query().$promise;
    }

    function getAccountsCoreData(accountIds, includeCollectedBalance, includePermissions) {
        return $resource(
            `${getChannelAPIPath()}accounttransactions/accounts/coredata`,
            {},
            { get: { method: 'GET', isArray: true } }
        ).get({
            accountIds,
            includeCollectedBalance,
            includePermissions,
        }).$promise;
    }
}
